/* eslint-disable max-len */

import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { helpers } from 'redux-firebasev3';
import { Link } from 'react-router';

import Page from '../../containers/Page';
import userPlaceholderImage from '../../images/userPlaceholder.svg';
import AddToSlackButton from '../../components/AddToSlackButton';
import Logo from '../../components/Logo';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

import slackImage from './slack.png';
import phoneImage from './phone.png';
import allCommandImage from './allCommand.png';
import feature1Image from './feature1.svg';
import feature2Image from './feature2.svg';
import feature3Image from './feature3.svg';
import learnMoreImage from './learnMore.svg';
import S from './style.css';

const { isLoaded, pathToJS } = helpers;

@connect(
  ({ firebase }) => ({
    authError: pathToJS(firebase, 'authError'),
    auth: pathToJS(firebase, 'auth'),
    profile: pathToJS(firebase, 'profile'),
  })
)
export default class Home extends Component {
  static propTypes = {
    auth: PropTypes.object,
    location: PropTypes.shape({
      query: PropTypes.shape({
        ref: PropTypes.string,
      }),
    }),
    profile: PropTypes.object,
  }

  render() {
    const {
      auth,
      location: { query: { ref } },
      profile,
    } = this.props;

    const isProductHunt = ref === 'producthunt';
    const pagePaddingClasses = 'ph6-l ph4-m ph3';
    const featureClasses = 'dtc-l mw5 mw-none-l ph3 center';

    const imageOrPlaceholder = profile && profile.image ?
      profile.image
      :
      userPlaceholderImage;

    const addToSlackOrViewTeamJSX = isLoaded(auth) && auth ?
      <Link
        className="white no-underline ba b--light-blue bw1 pa2 br3 dib dt fr"
        to="/dashboard"
      >
        <div className="dtc v-mid w-auto-ns">
          <img
            alt="Profile"
            className="br2"
            height="30px"
            src={imageOrPlaceholder}
            width="30px"
          />
        </div>
        <span className="app-f7 f5-ns dtc v-mid pl2">View Dashboard</span>
      </Link>
      :
      <AddToSlackButton type="outline" />;

    return (
      <Page>
        <div>

          <div className={`app-bg-gradient tc white ${pagePaddingClasses}`}>

            <div className="mw7 center">
              {isProductHunt &&
                <div className="tc pt3 pb2">
                  <div className="pv2" style={{ border: '2px solid #DA542F' }}>
                    <div className="f5 f4-ns mb2 serif">
                      <a
                        className="white pointer no-underline underline-hover"
                        href="https://postlight.com"
                        rel="noopener noreferrer"
                        target="_blank"
                      >
                        Postlight
                      </a>
                      &nbsp;&#9829;&rsquo;s ProductHunt!
                    </div>
                    <div className="f6 f5-ns">
                      We&rsquo;d <em>love</em> to hear your feedback:&nbsp;
                      <a
                        className="white pointer no-underline underline-hover"
                        href="mailto:sotu+producthunt@postlight.com"
                      >
                        sotu<span style={{ color: '#DA542F' }}>
                          +producthunt
                        </span>@postlight.com
                      </a>
                    </div>
                  </div>
                </div>
              }
              <div className="pt4 dt dt--fixed center">
                <div className="dtc-ns w-60-ns">
                  <div className="dt">
                    <div className="dtc-l w-75 w-auto-ns v-mid">
                      <Logo />
                    </div>
                    <span className="o-70 light-blue dn dtc-l v-mid i">
                      say /SO-two/, short for State of the Union
                    </span>
                  </div>
                </div>
                <div className="v-mid dtc w-25-ns w-40 center mt0-ns mt4">
                  {addToSlackOrViewTeamJSX}
                </div>
              </div>
              <div className="mt4 mt5-ns">
                <div className="f2 f1-ns serif b lightest-blue">
                  Stop sifting through Slack.
                </div>
                <div className="f5 f4-ns mt3">
                  Dropping in on a Slack channel is like listening to conference
                  calls backwards.
                </div>
                <div className="f5 f4-ns mt1">
                  SOTU gives you a bird's-eye view of all of your team&rsquo;s channels.
                </div>
              </div>
              <div className="mt4 relative">
                <img
                  alt="The chaos that is Slack"
                  src={slackImage}
                  style={{ marginBottom: '-6rem' }}
                  width="717px"
                />
                <img
                  alt="SOTU on your phone"
                  className={`${S.phone} absolute w-75 w-60-ns right-0`}
                  src={phoneImage}
                  width="473px"
                />
              </div>
            </div>
          </div>
          <div
            className={`${pagePaddingClasses} app-bg-near-white pb6-ns pb5`}
            style={{ paddingTop: '10rem' }}
          >
            <div className="dt-l center mw6-ns mw7-l">
              <div className="dtc-l v-mid center" style={{ width: '353px' }}>
                <img
                  alt="Stephanie uses the all command"
                  src={allCommandImage}
                  width="353px"
                />
              </div>
              <div className="dtc-l v-mid pl4-l ph3 mt0-l mt3">
                <div className="f3 serif b navy">
                  SOTU gives a snapshot of every project in your company—without
                  all the digging.
                </div>
                <div className="f5 mt2">
                  <div>
                    With just one command anyone on your team can provide the state
                    of the union for any project on Slack.
                  </div>

                  <div className="mt3">
                    To get caught up, use the /sotu command, or view the full channel
                    history on the SOTU dashboard when you're on the go.
                  </div>
                  <div className="mt3">
                    <AddToSlackButton />
                  </div>
                </div>
              </div>
            </div>

            <div className="mt5">
              <div className="f5 gray tc serif b tracked">
                GET YOUR OWN /SOTU IN THREE STEPS
              </div>
              <div className="dt-l tc mt4 center mw7">
                <div className={featureClasses}>
                  <img
                    alt="Add to SOTU"
                    src={feature1Image}
                  />
                  <div className="f4 b mt2">Add SOTU to your team’s Slack with one click</div>
                  <div className="f6 dark-gray mt2">
                    Every channel has access to push and pull statuses to SOTU.
                    Zero sign-ups required.
                  </div>
                </div>
                <div className={`${featureClasses} mt0-l mt4`}>
                  <img
                    alt="Ping your team"
                    src={feature2Image}
                  />
                  <div className="f4 b mt2">
                    Ping your team to update their status
                  </div>
                  <div className="f6 dark-gray mt2">
                    Remind a channel to send in a status at any time via the SOTU
                    dashboard.
                  </div>
                </div>
                <div className={`${featureClasses} mt0-l mt4`}>
                  <img
                    alt="High level brief"
                    src={feature3Image}
                  />
                  <div className="f4 b mt2">
                    Get the high-level brief wherever you are
                  </div>
                  <div className="f6 dark-gray mt2">
                    From the founder to the intern, everyone can check the
                    health of each team’s progress.
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={'app-bg-gradient tc white'}>
            <div className="f3 pv4 serif b">
              Keep tabs on your team&mdash;for free. Install SOTU today.
            </div>
            <div className="relative tc mt2">
              <div className="mt2">
                <AddToSlackButton />
                <Link className="pl2-ns mt2 mt0-ns db dib-ns" to="/how-to-sotu">
                  <img
                    alt="Learn more about SOTU"
                    height="40px"
                    src={learnMoreImage}
                  />
                </Link>
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </Page>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/pages/Home/index.jsx
 **/